import axios from "axios";
export default {
    AddTraining(form) {
        return axios.post(`/trainings`, form);
    },
    Check(id) {
        return axios.get(`/check-trainings/${id}`)
    },
};